import { createFileRoute } from "@tanstack/react-router";
import AdminKeystoneDiscontinued from "@/pages/admin/AdminKeystoneDiscontinued";

export const Route = createFileRoute("/_adminLayout/admin/keystone-discontinued")({
  component: AdminKeystoneDiscontinued,
});
